import apiClient from '../api/api'
import {
  BusinessUnitsResponse,
  BUKeywordsResponse,
  BusinessUnit,
  DepartmentsResponse,
} from '@/interfaces/businessUnit'

export const businessUnitsApi = {
  getBusinessUnits: async (): Promise<BusinessUnitsResponse> => {
    const response = await apiClient.get<BusinessUnitsResponse>('/business-units')
    return response.data
  },

  getDepartments: async (): Promise<DepartmentsResponse> => {
    const response = await apiClient.get<DepartmentsResponse>('/business-units/departments')
    return response.data
  },

  getBUKeywords: async (departmentName: string): Promise<BUKeywordsResponse> => {
    const endpoint = `/business-units/${departmentName}/keywords`
    const response = await apiClient.get<BUKeywordsResponse>(endpoint)
    return response.data
  },
}
